import {
  Backdrop,
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideSettings } from "../../redux/reducers/sidebar";
import { setNavigationBlocked, resetNavigationState } from "../../redux/reducers/controllNavigation";
import useControlledNavigation from "../../hooks/useControlledNavigation";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "400px",
};

const ConfirmExit = ({ open, setOpen, reNavigate, onExit }) => {
  const navigate = useControlledNavigation();
  const dispatch = useDispatch();
  const selectorDrawer = useSelector((state) => state.sidebarReducer?.settings);
  const blockedPath = useSelector((state) => state.controllNavigationSlice?.blockedPath);
  
  const modalClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  
  const handleLeave = () => {
    // Clear navigation blocking state
    dispatch(setNavigationBlocked(false));
    dispatch(resetNavigationState());
    
    // Navigate with force to bypass any blocking
    const destinationPath = reNavigate || blockedPath || '/';
    if (destinationPath) {
      navigate(destinationPath, { force: true });
    }
    
    setOpen(false);
    
    if (onExit) {
      onExit("leave");
    }
    
    if (selectorDrawer == true) {
      dispatch(hideSettings());
    }
  };

  return (
    <Modal
      disableRestoreFocus
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      onClose={modalClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Changes are not saved
                <IconButton aria-label="delete" onClick={modalClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              padding: "15px",
              // height:{xs:"400px",sm:'auto'},
            }}
          >
            <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
              Are you sure you want to leave this page without saving your
              changes?
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={modalClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Stay on Page
            </Button>
            {open && (
              <Button
                onClick={handleLeave}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Leave Page
              </Button>
            )}
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
export default ConfirmExit;
